import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import {
  formatWordCountLabel,
  longTextPlaceholder,
  textAnswerCharCount,
  textAnswerWordCount,
} from '../../../lib/text-answer'
import type { SurveyQuestion } from '../../../lib/survey-question.types'
import {
  surveyLongTextFieldSx,
  surveyLongTextFooterRowSx,
  surveyLongTextMetaSx,
  surveyLongTextRootSx,
} from '../../../styles/surveyExecutionStyles'

interface LongTextQuestionProps {
  readonly question: SurveyQuestion
  readonly value: string | null
  readonly onChange: (value: string) => void
}

export function LongTextQuestion({ question, value, onChange }: LongTextQuestionProps) {
  const current = value ?? ''
  const charCount = textAnswerCharCount(current)
  const wordCount = textAnswerWordCount(current)
  const maxLength = question.maxLength ?? undefined
  const minLength = question.minLength ?? undefined

  return (
    <Box sx={surveyLongTextRootSx} data-testid={`survey-q-${question.id}-long-text`}>
      <TextField
        fullWidth
        multiline
        minRows={4}
        value={current}
        placeholder={longTextPlaceholder(question)}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{
          'data-testid': `survey-q-${question.id}-long-text-input`,
          'aria-label': question.prompt,
          ...(minLength == null ? {} : { minLength }),
          ...(maxLength == null ? {} : { maxLength }),
        }}
        sx={surveyLongTextFieldSx}
      />
      <Box sx={surveyLongTextFooterRowSx}>
        <Typography
          component="span"
          sx={surveyLongTextMetaSx}
          data-testid={`survey-q-${question.id}-long-text-words`}
          aria-live="polite"
        >
          {formatWordCountLabel(wordCount)}
        </Typography>
        {maxLength == null ? null : (
          <Typography
            component="span"
            sx={surveyLongTextMetaSx}
            data-testid={`survey-q-${question.id}-long-text-counter`}
            aria-live="polite"
          >
            {`${charCount} / ${maxLength}`}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
